import React from 'react';
import './LoadingPage.css';
import Logo from '../Assets/RubyandRed_Logo_V1.png'; // Ensure you have the correct path to your logo image

const LoadingPage = () => {
  return (
    <div className="loading-container">
      <div className="loading-content">
        {/* Display the logo without spinning */}
        <img src={Logo} alt="Loading Logo" className="loading-logo" />
        {/* Keep the spinner */}
        <div className="spinner"></div>
        <h2>Loading, please wait...</h2>
      </div>
    </div>
  );
};

export default LoadingPage;
